export const formDirection = (direction) => {
    if (direction == 'horz')
        return `
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            > div {
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                a{
                    padding: 0 2px;
                }
            }
        `;
    else return ``;
};
